import { Package, Palette } from 'lucide-react'
// import { Tab } from 'src/shared/components/TabNavigation'

export const TABS = [
  {
    id: 'product',
    label: 'Product',
    icon: <Package className="h-4 w-4" />,
  },
  // {
  //   id: 'variants',
  //   label: 'Variants',
  //   icon: <Layers className="h-4 w-4" />,
  // },
  {
    id: 'colors',
    label: 'Colors',
    icon: <Palette className="h-4 w-4" />,
  },
] as const

export const DEFAULT_DRAFT_PRODUCT = {
  item_name: '-',
  item_description: '-',
  has_variants: false,
  is_draft: true,
} as const
